import React from 'react';
import '../App.css';
import profileImg from '../Images/sharjeel baig.PNG';
import contact from '../views/contact';
import { Link } from 'react-router-dom'

function showLinks() {
    // var links = document.getElementById('headerLinks');
    // if (links.style.height == '60px') {
    //     links.style.height = '0px';
    // } else {
    //     links.style.height = '60px';
    // }
var bodyVar = document.getElementById('body');
    if (bodyVar.style.top == "160px") {
        bodyVar.style.top = "100px";
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } else {
        bodyVar.style.top = "160px"
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
}



const Header = () => {
    return ( 
        <>
        <div className="Header" id="header" >
<div className="horizontalLayout" style={{width:'100%'}}>
            {/* menu */}
            <div style={{width:'10%'}} className="menuBtn" onClick={showLinks}>
                <div className="menuBar"></div>
                <div className="menuBar"></div>
                <div className="menuBar"></div>

            </div>
          
           {/* text */}
           
<div style={{alignSelf:'center',fontSize:'80%',width:'80%'}}><h1>Sharjeel Baig</h1></div>

{/* profile image */}
<div className="profileImgSmallDiv">
   <img style={{height:55, borderRadius:10,}} src={profileImg} /> 
</div>

</div>
</div>

       

           {/* Links */}

<div id='headerLinks' className="headerLinks">
<center>
<Link style={{textDecoration:'none'}} to='/contact' ><button className='headerLink' >Contact</button></Link>
<Link style={{textDecoration:'none'}} to='/myWorks' ><button className='headerLink'>My Works</button></Link>
<Link style={{textDecoration:'none'}} to='/About' ><button className='headerLink'>About Me</button></Link>
</center>
   
</div>


</>
     );
}
 
export default Header;